import { NgModule } from '@angular/core';
import { SharedModule } from './../shared/shared.module';
import { SelectLocationsComponent } from './components/select-locations/select-locations.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { SelectRequiredSkillsComponent } from './components/select-required-skills/select-required-skills.component';
import { SelectChecklistComponent } from './components/select-checklist/select-checklist.component';
import { SelectChecklistMulPropsComponent } from './components/select-checklist-mul-props/select-checklist-mul-props.component';

import { FileInputComponent } from './components/file-input/file-input.component';
import { ThumbnailPreviewComponent } from './components/thumbnail-preview/thumbnail-preview.component';
import { SelectStartTriggerWoComponent } from './components/select-start-trigger-wo/select-start-trigger-wo.component';
import { SelectCompleteTriggerWoComponent } from './components/select-complete-trigger-wo/select-complete-trigger-wo.component';
import { ErrorSummaryComponent } from './components/error-summary/error-summary.component';
import { DialogFactoryService } from '@core/services/dialog-factory.service';
import { SelectTaskDialogComponent } from './components/select-task-dialog/select-task-dialog.component';
import { SelectStaffDialogComponent } from './components/select-staff-dialog/select-staff-dialog.component';
import { ConsoleComponent } from './components/console/console.component';
import { FiltersDialogComponent } from './components/filters-dialog/filters-dialog.component';
import { PartsCostDialogComponent } from './components/parts-cost-dialog/parts-cost-dialog.component';
import { PartsBackorderDialogComponent } from './components/parts-backorder-dialog/parts-backorder-dialog.component';
import { SelectChecklistDialogComponent } from './components/select-checklist-dialog/select-checklist-dialog.component';
import { SelectUserGroupsComponent } from './components/select-user-groups/select-user-groups.component';
import { SelectPmComponent } from './components/select-pm/select-pm.component';
import { SelectPmWithPropComponent } from './components/select-pm-with-property/select-pm-property.component';

import { SelectReasonComponent } from './components/select-reason/select-reason.component';
import { ChecklistListingComponent } from './components/checklist-listing/checklist-listing.component';
import { SearchBoxedComponent } from './components/search-boxed/search-boxed.component';
import { ChecklistItemsListingDialogComponent } from './components/checklist-items-listing-dialog/checklist-items-listing-dialog.component';
import { AssignStaffDialogComponent } from './components/assign-staff-dialog/assign-staff-dialog.component';
import { SelectStaffComponent } from './components/select-staff/select-staff.component';
import { ConfirmActionDialogComponent } from './components/confirm-action-dialog/confirm-action-dialog.component';
import { AssetMetricsComponent } from './components/asset-metrics/asset-metrics.component';
import { AssetMetricsAddEditComponent } from './components/asset-metrics-add-edit/asset-metrics-add-edit.component';
import { AssetMetricHistoryDialogComponent } from './components/asset-metric-history-dialog/asset-metric-history-dialog.component';
import { AssetMetricStateHistoryDialogComponent } from './components/asset-metric-state-history-dialog/asset-metric-state-history-dialog.component';
import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { AuditDialogComponent } from './components/audit-dialog/audit-dialog.component';
import { AuditInfoComponent } from './components/audit-info/audit-info.component';
import { QrcodeCreateDialogComponent } from './components/qrcode-create-dialog/qrcode-create-dialog.component';
import { AssetMetricItemComponent } from './components/asset-metric-item/asset-metric-item.component';
import { SelectMetricsComponent } from './components/select-metrics/select-metrics.component';
import { SelectMetricTypeComponent } from './components/select-metric-type/select-metric-type.component';

import { SelectableAccordionComponent } from './components/selectable-accordion/selectable-accordion.component';
import { TaskMasterItemComponent } from './components/task-master-item/task-master-item.component';
import { TaskGroupMasterItemComponent } from './components/task-group-master-item/task-group-master-item.component';
import { DurationFromSecsPipe } from './pipes/duration-from-secs.pipe';
import { SelectAssetsDialogComponent } from './components/select-assets-dialog/select-assets-dialog.component';
import { SelectItemsDialogComponent } from './components/select-items-dialog/select-items-dialog.component';
import { ListingDialogComponent } from './components/listing-dialog/listing-dialog.component';
import { NotesDialogComponent } from './components/notes-dialog/notes-dialog.component';
import { WorkorderStatusIconDirective } from './directives/workorder-status-icon.directive';
import { ConsoleSearchComponent } from './components/console-search/console-search.component';
import { ResponseConfigSummaryComponent } from './components/response-config-summary/response-config-summary.component';
import { KmtSelectAssetCategoryComponent } from './components/kmt-select-asset-category/kmt-select-asset-category.component';
import { KmtSelectAssetComponent } from './components/kmt-select-asset/kmt-select-asset.component';
import { KmtChipsAssetComponent } from './components/kmt-chips-asset/kmt-chips-asset.component';
import { ResponseInputComponent } from './components/response-input/response-input.component';
import { TableDateFormatPipe } from './pipes/table-date-format.pipe';
import { DurationInputComponent } from './components/duration-input/duration-input.component';
import { DurationTypedInputComponent } from './components/duration-typed-input/duration-typed-input.component';
import { FileUploadProgressComponent } from './components/file-upload-progress/file-upload-progress.component';
import { SelectWeekdayComponent } from './components/select-weekday/select-weekday.component';
import { SelectMonthdayComponent } from './components/select-monthday/select-monthday.component';
import { AllFiltersDialogComponent } from './components/all-filters-dialog/all-filters-dialog.component';
import { SelectWoDescriptionComponent } from './components/select-wo-description/select-wo-description.component';
import { SelectWoJobDescriptionComponent } from './components/select-wo-job-description/select-wo-job-description.component';
import { SelectJobDescriptionComponent } from './components/select-job-description/select-job-description.component';
import { SelectWoTypeComponent } from './components/select-wo-type/select-wo-type.component';
import { SelectWoStatusComponent } from './components/select-wo-status/select-wo-status.component';
import { SelectWoSourceComponent } from './components/select-wo-source/select-wo-source.component';
import { SelectScheduleTypeComponent } from './components/select-schedule-type/select-schedule-type.component';
import { AttachedPreviewComponent } from './components/attached-preview/attached-preview.component';
import { FileInputDialogComponent } from './components/file-input-dialog/file-input-dialog.component';
import { FilesizePipe } from './pipes/filesize.pipe';
import { NodeFileInputDialogComponent } from './components/file-input-dialog/node-file-input-dialog.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { AssetTxnTableComponent } from './components/asset-txn-table/asset-txn-table.component';
import { SelectAssetMakeComponent } from './components/select-asset-make/select-asset-make.component';
import { SelectAssetModelComponent } from './components/select-asset-model/select-asset-model.component';
import { SelectCostCenterComponent } from './components/select-cost-center/select-cost-center.component';
import { SelectTranslationStatusComponent } from './components/select-translation-status/select-translation-status.component';

import { SelectCompanyComponent } from './components/select-company/select-company.component';
import { AddEditCompanyComponent } from './components/add-edit-company/add-edit-company.component';
import { AddEditAssetServiceComponent } from './components/add-edit-asset-service/add-edit-asset-service.component';
import { ViewAssetServiceComponent } from './components/view-asset-service/view-asset-service.component';
import { EditAssetServicesDialogComponent } from './components/edit-asset-services-dialog/edit-asset-services-dialog.component';
import { PhotoCoverUploadComponent } from './components/photo-cover-upload/photo-cover-upload.component';
import { PropertyCurrencyPipe } from './pipes/property-currency.pipe';
import { GuestLookupComponent } from './components/guest-lookup/guest-lookup.component';
import { SelectDescComboComponent } from './components/select-desc-combo/select-desc-combo.component';
import { SelectPriorityComponent } from './components/select-priority/select-priority.component';
import { SelectEventComponent } from './components/select-event/select-event.component';
import { MessageSidebarComponent } from './components/message-sidebar/message-sidebar.component';
import { SelectStaffAsyncComponent } from './components/select-staff-async/select-staff-async.component';
import { SelectAssetSimpleDialogComponent } from './components/select-asset-simple-dialog/select-asset-simple-dialog.component';
import { SelectChecklistSimpleDialogComponent } from './components/select-checklist-simple-dialog/select-checklist-simple-dialog.component';
import { PropertyCodePipe } from './pipes/property-code.pipe';
import { SelectStaffDepartmentComponent } from './components/select-staff-department/select-staff-department.component';
import { SelectDesignationComponent } from './components/select-designation/select-designation.component';
import { StatusIconDirective } from './directives/status-icon.directive';
import { ColorPickerInputComponent } from './components/color-picker-input/color-picker-input.component';
import { ColorPaletteComponent } from './components/color-palette/color-palette.component';
import { ColorPickerPopoverComponent } from './components/color-picker-popover/color-picker-popover.component';
import { ObjectStatusIconDirective } from './directives/objectstatus-icon.directive';
import { DocumentUploadTableComponent } from '@features/common/components/document-upload-table/document-upload-table.component';
import { SelectAssetDocTypeComponent } from './components/select-asset-doc-type/select-asset-doc-type.component';
import { EditAssetDocumentDialogComponent } from './components/edit-asset-document-dialog/edit-asset-document-dialog.component';
import { DurationFromMinsPipe } from './pipes/duration-from-mins.pipe';
import { SelectExcelImportComponent } from './components/select-excel-import/select-excel-import.component';
import { SelectExcelImportDialogComponent } from './components/select-excel-import-dialog/select-excel-import-dialog.component';
import { SelectLanguagesComponent } from './components/select-languages/select-languages.component';
import { SelectLanguagesDialogComponent } from './components/select-languages-dialog/select-languages-dialog.component';
import { SelectResStatusComponent } from './components/select-res-status/select-res-status.component';
import { SelectGroupComponent } from './components/select-group/select-group.component';
import { SelectDepartmentComponent } from './components/select-department/select-department.component';
import { SelectSkillsComponent } from './components/select-skills/select-skills.component';
import { PmAssetLocationComboComponent } from './components/pm-asset-location-combo/pm-asset-location-combo.component';
import { SelectCompanyContractorComponent } from './components/select-company-contractor/select-company-contractor.component';
import { TwoDigitDecimaNumberDirective } from './directives/two-decimal-digits.directive';
import { RemarksInputDialogComponent } from './components/remarks-input-dialog/remarks-input-dialog.component';
import { SelectApprovalComponent } from './components/select-approval/select-approval.component';
import { BalancedPMValidationCheckDialogComponent } from './components/pm-validation-check-import-dialog/pm-validation-check-import-dialog.component';
import { PMSlotInfoDialogComponent } from './components/pm-slot-info-dialog/pm-slot-info-dialog.component';
import { SelectSortedSkillsComponent } from './components/select-sorted-skills/select-sorted-skills.component';

@NgModule({
  declarations: [
    SelectLocationsComponent,
    SelectRequiredSkillsComponent,
    SelectChecklistComponent,
    SelectChecklistMulPropsComponent,
    FileInputComponent,
    ThumbnailPreviewComponent,
    SelectStartTriggerWoComponent,
    SelectCompleteTriggerWoComponent,
    ErrorSummaryComponent,
    SelectTaskDialogComponent,
    SelectStaffDialogComponent,
    ConsoleComponent,
    SelectChecklistDialogComponent,
    FiltersDialogComponent,
    PartsCostDialogComponent,
    PartsBackorderDialogComponent,
    SelectChecklistDialogComponent,
    SelectUserGroupsComponent,
    SelectPmComponent,
    SelectPmWithPropComponent,
    SelectReasonComponent,
    ChecklistListingComponent,
    ChecklistItemsListingDialogComponent,
    AssignStaffDialogComponent,
    SelectStaffComponent,
    ConfirmActionDialogComponent,
    AssetMetricsComponent,
    AssignStaffDialogComponent,
    AssetMetricsAddEditComponent,
    SearchBoxedComponent,
    PMSlotInfoDialogComponent,
    AssetMetricHistoryDialogComponent,
    AssetMetricStateHistoryDialogComponent,
    InfoDialogComponent,
    AlertDialogComponent,
    ConfirmDialogComponent,
    AuditDialogComponent,
    AuditInfoComponent,
    QrcodeCreateDialogComponent,
    AssetMetricItemComponent,
    SelectableAccordionComponent,
    TaskMasterItemComponent,
    TaskGroupMasterItemComponent,
    DurationFromSecsPipe,
    SelectAssetsDialogComponent,
    SelectMetricsComponent,
    SelectMetricTypeComponent,
    SelectableAccordionComponent,
    SelectItemsDialogComponent,
    ListingDialogComponent,
    NotesDialogComponent,
    WorkorderStatusIconDirective,
    TwoDigitDecimaNumberDirective,
    ConsoleSearchComponent,
    ResponseConfigSummaryComponent,
    KmtSelectAssetCategoryComponent,
    KmtSelectAssetComponent,
    KmtChipsAssetComponent,
    PmAssetLocationComboComponent,
    ResponseInputComponent,
    TableDateFormatPipe,
    DurationInputComponent,
    DurationTypedInputComponent,
    FileUploadProgressComponent,
    SelectWeekdayComponent,
    SelectMonthdayComponent,
    AllFiltersDialogComponent,
    SelectWoDescriptionComponent,
    SelectWoJobDescriptionComponent,
    SelectJobDescriptionComponent,
    SelectWoTypeComponent,
    SelectWoStatusComponent,
    SelectWoSourceComponent,
    SelectScheduleTypeComponent,
    AttachedPreviewComponent,
    FileInputDialogComponent,
    FilesizePipe,
    NodeFileInputDialogComponent,
    PageHeaderComponent,
    AssetTxnTableComponent,
    SelectAssetMakeComponent,
    SelectAssetModelComponent,
    SelectCostCenterComponent,
    SelectTranslationStatusComponent,
    SelectCompanyComponent,
    SelectCompanyContractorComponent,
    AddEditCompanyComponent,
    AddEditAssetServiceComponent,
    ViewAssetServiceComponent,
    EditAssetServicesDialogComponent,
    PhotoCoverUploadComponent,
    PropertyCurrencyPipe,
    GuestLookupComponent,
    SelectDescComboComponent,
    SelectPriorityComponent,
    SelectEventComponent,
    MessageSidebarComponent,
    SelectStaffAsyncComponent,
    SelectDepartmentComponent,
    SelectSkillsComponent,
    SelectSortedSkillsComponent,
    SelectAssetSimpleDialogComponent,
    SelectChecklistSimpleDialogComponent,
    PropertyCodePipe,
    SelectStaffDepartmentComponent,
    SelectDesignationComponent,
    StatusIconDirective,
    ObjectStatusIconDirective,
    ColorPickerInputComponent,
    ColorPaletteComponent,
    ColorPickerPopoverComponent,
    DocumentUploadTableComponent,
    SelectAssetDocTypeComponent,
    EditAssetDocumentDialogComponent,
    DurationFromMinsPipe,
    SelectExcelImportComponent,
    SelectExcelImportDialogComponent,
    SelectLanguagesComponent,
    SelectLanguagesDialogComponent,
    SelectResStatusComponent,
    SelectGroupComponent,
    RemarksInputDialogComponent,
    SelectApprovalComponent,
    BalancedPMValidationCheckDialogComponent,
  ],
  imports: [SharedModule, NgSelectModule, FormsModule],
  exports: [
    NgSelectModule,
    SelectLocationsComponent,
    SelectRequiredSkillsComponent,
    SelectChecklistComponent,
    SelectChecklistMulPropsComponent,
    FileInputComponent,
    ThumbnailPreviewComponent,
    SelectStartTriggerWoComponent,
    SelectCompleteTriggerWoComponent,
    ErrorSummaryComponent,
    SelectTaskDialogComponent,
    ConsoleComponent,
    FiltersDialogComponent,
    PartsCostDialogComponent,
    PartsBackorderDialogComponent,
    SearchBoxedComponent,
    SelectPmComponent,
    SelectPmWithPropComponent,
    SelectReasonComponent,
    SelectUserGroupsComponent,
    ChecklistListingComponent,
    ChecklistListingComponent,
    ChecklistItemsListingDialogComponent,
    ConfirmActionDialogComponent,
    AssetMetricsComponent,
    AssetMetricsAddEditComponent,
    InfoDialogComponent,
    AlertDialogComponent,
    ConfirmDialogComponent,
    ChecklistItemsListingDialogComponent,
    AuditDialogComponent,
    AuditInfoComponent,
    QrcodeCreateDialogComponent,
    AssetMetricItemComponent,
    SelectableAccordionComponent,
    TaskGroupMasterItemComponent,
    TaskMasterItemComponent,
    DurationFromSecsPipe,
    TableDateFormatPipe,
    SelectMetricsComponent,
    SelectMetricTypeComponent,
    SelectableAccordionComponent,
    SelectItemsDialogComponent,
    ListingDialogComponent,
    NotesDialogComponent,
    WorkorderStatusIconDirective,
    TwoDigitDecimaNumberDirective,
    ResponseConfigSummaryComponent,
    ResponseInputComponent,
    KmtSelectAssetCategoryComponent,
    KmtSelectAssetComponent,
    KmtChipsAssetComponent,
    SelectStaffComponent,
    DurationInputComponent,
    DurationTypedInputComponent,
    FileUploadProgressComponent,
    SelectWeekdayComponent,
    SelectMonthdayComponent,
    AllFiltersDialogComponent,
    SelectWoDescriptionComponent,
    SelectWoJobDescriptionComponent,
    SelectJobDescriptionComponent,
    SelectWoTypeComponent,
    SelectWoStatusComponent,
    SelectWoSourceComponent,
    SelectScheduleTypeComponent,
    AttachedPreviewComponent,
    FileInputDialogComponent,
    FilesizePipe,
    NodeFileInputDialogComponent,
    ConsoleSearchComponent,
    PageHeaderComponent,
    AssetTxnTableComponent,
    SelectAssetMakeComponent,
    SelectAssetModelComponent,
    SelectCostCenterComponent,
    SelectTranslationStatusComponent,
    SelectCompanyComponent,
    SelectCompanyContractorComponent,
    AddEditCompanyComponent,
    EditAssetServicesDialogComponent,
    ViewAssetServiceComponent,
    PhotoCoverUploadComponent,
    PropertyCurrencyPipe,
    GuestLookupComponent,
    SelectDescComboComponent,
    SelectPriorityComponent,
    SelectEventComponent,
    MessageSidebarComponent,
    SelectStaffAsyncComponent,
    SelectDepartmentComponent,
    SelectSkillsComponent,
    SelectSortedSkillsComponent,
    SelectAssetSimpleDialogComponent,
    SelectChecklistSimpleDialogComponent,
    PropertyCodePipe,
    SelectStaffDepartmentComponent,
    SelectDesignationComponent,
    StatusIconDirective,
    ObjectStatusIconDirective,
    ColorPickerInputComponent,
    ColorPaletteComponent,
    ColorPickerPopoverComponent,
    DocumentUploadTableComponent,
    SelectAssetDocTypeComponent,
    EditAssetDocumentDialogComponent,
    DurationFromMinsPipe,
    SelectExcelImportComponent,
    SelectExcelImportDialogComponent,
    SelectLanguagesComponent,
    SelectLanguagesDialogComponent,
    SelectResStatusComponent,
    SelectGroupComponent,
    BalancedPMValidationCheckDialogComponent,
  ],
  entryComponents: [
    SelectTaskDialogComponent,
    SelectStaffDialogComponent,
    SelectChecklistDialogComponent,
    SelectChecklistDialogComponent,
    FiltersDialogComponent,
    ConfirmActionDialogComponent,
    ChecklistItemsListingDialogComponent,
    AssignStaffDialogComponent,
    AssetMetricsAddEditComponent,
    AssetMetricHistoryDialogComponent,
    AssetMetricStateHistoryDialogComponent,
    InfoDialogComponent,
    AlertDialogComponent,
    ConfirmDialogComponent,
    AuditDialogComponent,
    QrcodeCreateDialogComponent,
    SelectAssetsDialogComponent,
    SelectItemsDialogComponent,
    ListingDialogComponent,
    NotesDialogComponent,
    AllFiltersDialogComponent,
    FileInputDialogComponent,
    NodeFileInputDialogComponent,
    AddEditCompanyComponent,
    SelectAssetSimpleDialogComponent,
    SelectChecklistSimpleDialogComponent,
    SelectExcelImportDialogComponent,
    SelectLanguagesDialogComponent,
    BalancedPMValidationCheckDialogComponent,
  ],
  providers: [DialogFactoryService, FilesizePipe],
})
export class UiModule {}
